import React, { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SettingsSVG from '../../svgs/SettingsSVG';
import TablesSVG from '../../svgs/TablesSVG';
import ProfileSVG from '../../svgs/ProfileSVG';
import CalendarSVG from '../../svgs/CalendarSVG';
import DashboardSVG from '../../svgs/DashboardSVG';

const PurchaserSidebarMenu: React.FC = () => {
    const location = useLocation();
    const { pathname } = location;

    return (
        <>
<nav className="mt-5 py-4 px-4 lg:mt-9 lg:px-6">
                    
                    <div>
                    <h3 className="mb-4 ml-4 text-sm font-semibold text-bodydark2">
                        MENU
                    </h3>

                    <ul className="mb-6 flex flex-col gap-1.5">
                
                        <li>
                        <NavLink
                            to="/"
                            className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                            pathname.includes('/') &&
                            'bg-graydark dark:bg-meta-4'
                            }`}
                        >
                            <DashboardSVG />
                            Dashboard
                        </NavLink>
                        </li>
                        <li>
                        <NavLink
                            to="/calendar"
                            className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                            pathname.includes('calendar') &&
                            'bg-graydark dark:bg-meta-4'
                            }`}
                        >
                            <CalendarSVG />
                            Calendar
                        </NavLink>
                        </li>                
                        <li>
                        <NavLink
                            to="/profile"
                            className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                            pathname.includes('profile') && 'bg-graydark dark:bg-meta-4'
                            }`}
                        >
                            <ProfileSVG />
                            Profile
                        </NavLink>
                        </li>                                 
                    </ul>

                    </div>

                </nav>  
        </>        
    );
};

export default PurchaserSidebarMenu;